import React, { Fragment, useState, useRef } from 'react'
import { Button, Form, Modal, Row, Col } from 'react-bootstrap'
import callapi from '../../helpers/callapi'
import { handleEnterKey } from '../../helpers/checkEnter'
import { useDispatch } from 'react-redux'
import { groupBy, reduce } from 'lodash'

const CreateOrderModal = ({ isShow, onClickCancel }) => {
  const [userId, setUserId] = useState('')
  const [user, setUser] = useState({})
  const [cartId, setCartId] = useState('')
  const [cart, setCart] = useState({})
  const [lotteriesFromSearched, setLotteriesFromSearched] = useState({})
  const [lotteriesFromCart, setLotteriesFromCart] = useState([])
  const [type, setType] = useState('series')
  const numberForSearchRef = useRef()

  let maxCount = 0
  const dispatch = useDispatch()

  const groupLotteries = (initLotteries, groupType) => {
    let lotteriesGroupByNumber = groupBy(initLotteries, groupType)
    const remainingLotteries = []
    const groupResults = reduce(
      lotteriesGroupByNumber,
      (result, lotteryGroup, key) => {
        if (lotteryGroup.length > 1) {
          const firstItem = lotteryGroup[0]
          result.push({
            lotteries: lotteryGroup,
            number: firstItem.number,
            groupKey: key,
            count: lotteryGroup.length,
          })
        } else {
          remainingLotteries.push(...lotteryGroup)
        }
        maxCount = maxCount > lotteryGroup.length ? maxCount : lotteryGroup.length
        return result
      },
      [],
    )
    return {
      result: groupResults,
      remaining: remainingLotteries,
    }
  }

  const searchUser = async () => {
    try {
      dispatch({ type: 'loading_show' })

      const user = await callapi({
        url: `/users/phone/${userId.toUpperCase()}`,
      })

      const { cartId: idOfCart } = await callapi({
        url: '/carts/initCartAdmin',
        method: 'post',
        body: { userId: user.id },
      })

      setUser(user)
      setCartId(idOfCart)
      dispatch({ type: 'loading_hide' })
    } catch (e) {
      console.log({ message: e })
      alert('ไม่มี userId นี้อยู่')
      dispatch({ type: 'loading_hide' })
    }
  }

  const searchLotteries = async () => {
    try {
      dispatch({ type: 'loading_show' })
      let query = { type: type }
      let queryFields = ['d1', 'd2', 'd3', 'd4', 'd5', 'd6']
      let search = numberForSearchRef?.current?.value.padStart(6, 'x')
      let numbers = search.split('')

      numbers.forEach((x, i) => {
        if (x !== 'x') {
          query[queryFields[i]] = x
        }
      })

      let lotteries = await callapi({
        url: '/lotteries/search',
        query: query,
      })

      delete lotteries.data.gseries
      setLotteriesFromSearched(lotteries.data)
    } catch (e) {
      console.log({ message: e })
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  const addLotteryToCart = async (lsid, typeLotto) => {
    try {
      dispatch({ type: 'loading_show' })
      let url
      let body
      let cLotteriesFromSearched = { ...lotteriesFromSearched } // {series:[],single:[]}

      if (typeLotto === 'series') {
        url = `/carts/${cartId}/series`
        body = { lsid }
      } else if (typeLotto === 'single') {
        url = `/carts/addItem`
        body = { cartId, items: [lsid] }
      }

      await callapi({ url: url, method: 'post', body: body })
      const removeLotterySelected = cLotteriesFromSearched[typeLotto].filter((v) => v.id != lsid)

      cLotteriesFromSearched[typeLotto] = removeLotterySelected
      // เมื่อหวยเข้า database ต้อง fetchCart ตะกร้ามาแสดงที่ UI
      fetchCart()
      setLotteriesFromSearched(cLotteriesFromSearched)
    } catch (e) {
      console.log({ message: e })
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  const fetchCart = async () => {
    try {
      // lotteriesInCart ---> ["64-38-16-351211", "64-38-27-291411", "64-38-31-252811"]
      const { items: lotteriesInCart } = await callapi({
        url: '/carts/' + cartId,
      })

      const recheckLotteriesInCart = await callapi({
        url: '/lotteries/carts',
        body: { ids: lotteriesInCart },
      })

      // แบ่งประเภทหวย
      const { result: series, remaining: single } = groupLotteries(recheckLotteriesInCart, 'number')

      setCart({ series, single })
      setLotteriesFromCart(lotteriesInCart)
    } catch (e) {
      console.log({ message: e })
    }
  }

  const removeLottery = async (num) => {
    try {
      dispatch({ type: 'loading_show' })

      // ลบ lottery ที่เลือก,คืนหวยเข้าสู่ระบบ และ แสดงหวยคงเหลือ
      const { items: lotteriesRemain } = await callapi({
        url: '/carts/removeItem',
        body: {
          cartId,
          items: lotteriesFromCart.filter((v) => v.split('-')[3] === num),
        },
      })

      // get หวยที่เหลืออยู่ในตะกร้า ถ้าหวยหมดตะกร้า ตะกร้าจะถูกลบ หรือ หายไป
      const cart = await callapi({
        url: '/lotteries/carts',
        body: { ids: lotteriesRemain },
      })

      // สร้าง ตะกร้าขึ้นมาใหม่
      if (cart.length === 0) {
        const { cartId: newCartId } = await callapi({
          url: '/carts/initCartAdmin',
          method: 'post',
          body: { userId: user.id },
        })
        setCartId(newCartId)
      }

      // แบ่งประเภทหวย
      const { result: series, remaining: single } = groupLotteries(cart, 'number')

      setLotteriesFromCart(lotteriesRemain)
      setCart({ series, single })
    } catch (e) {
      console.log({ message: e })
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  const createOrder = async () => {
    try {
      dispatch({ type: 'loading_show' })
      // เก็บ array หวยที่อยู่ในตะกร้าทั้งหมด ทั้ง series และ single
      let lotteriesToCreateOrder = []
      cart.series.forEach((v) => {
        v.lotteries.forEach((n) => {
          lotteriesToCreateOrder.push(n.id)
        })
      })
      cart.single.forEach((n) => {
        lotteriesToCreateOrder.push(n.id)
      })

      // สร้าง order
      const order = await callapi({
        url: '/orders/admin',
        method: 'post',
        body: { userId: user.id, lotteries: lotteriesToCreateOrder },
      })

      // checkoutCart ---> ลบตะกร้าทิ้งเพราะหวยย้ายไปอยู่ใน order แล้ว
      await callapi({ url: '/carts/checkoutCart', body: { cartId } })

      if (order.success) {
        alert('สร้าง order สำเร็จ')
      }

      clearState()
    } catch (e) {
      console.log({ message: e })
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  const closeModal = async () => {
    try {
      dispatch({ type: 'loading_show' })
      if (cartId) {
        if (lotteriesFromCart.length > 0) {
          // ลบตะกร้า, คืนหวยเข้าสู่ระบบ และ แสดงหวยคงเหลือ
          await callapi({
            url: '/carts/removeItem',
            body: {
              cartId,
              items: lotteriesFromCart,
            },
          })
        } else {
          await callapi({ url: '/carts/checkoutCart', body: { cartId } })
        }
      }
      onClickCancel()
      clearState()
    } catch (e) {
      console.log({ message: e })
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  const clearState = () => {
    setUserId('')
    setUser({})
    setType('series')
    setCart({})
    setCartId('')
    setLotteriesFromCart([])
    setLotteriesFromSearched({})
  }

  const validNumberForSearch = (e) => {
    numberForSearchRef.current.value = e.target.value.replace(/[^0-9xX]/g, '')
  }

  const displayLotteriesFromSearched = () => {
    return (
      <div>
        {Object.keys(lotteriesFromSearched).length > 0 && (
          <div>
            {(lotteriesFromSearched.series.length > 0 || lotteriesFromSearched.single.length > 0) && (
              <h3 className="p-0 text-center">ผลการค้นหา</h3>
            )}
            {Object.keys(lotteriesFromSearched).map((type) => {
              return (
                <div key={type}>
                  {lotteriesFromSearched[type].map((v) => {
                    return (
                      <div key={v.id}>
                        <p
                          onClick={() => addLotteryToCart(v.id, type)}
                          className="d-inline-block"
                          style={{ cursor: 'pointer' }}
                        >
                          {v.number} {type === 'series' ? `ชุด (${v.items.length})` : `(1)`} ใบ
                        </p>
                        <br />
                      </div>
                    )
                  })}
                </div>
              )
            })}
          </div>
        )}
      </div>
    )
  }

  const displayLotteriesInCart = () => {
    return (
      <div>
        {Object.keys(cart).length > 0 && (
          <div>
            {(cart.series.length > 0 || cart.single.length > 0) && (
              <div>
                <hr className="bg-primary" />
                <h3 className="p-0 text-center">ลอตเตอรี่ที่เลือก</h3>
              </div>
            )}
            {Object.keys(cart).map((type) => {
              return (
                <div key={type}>
                  {cart[type].map((v) => {
                    return (
                      <div key={v.number}>
                        <p className="d-inline-block">
                          {v.number}
                          {type === 'series' ? `ชุด (${v.count})` : ` (1)`} ใบ
                        </p>{' '}
                        <span
                          className="text-danger"
                          onClick={() => removeLottery(v.number)}
                          style={{ cursor: 'pointer' }}
                        >
                          ลบ
                        </span>
                      </div>
                    )
                  })}
                </div>
              )
            })}
          </div>
        )}
      </div>
    )
  }

  return (
    <Fragment>
      <Modal show={isShow} size="xl">
        <Modal.Header>
          <h3>สร้างคำสั่งซื้อใหม่</h3>
        </Modal.Header>
        <Modal.Body>
          {!user.name ? (
            <Form>
              <Form.Label className="ml-2">รหัสลูกค้า</Form.Label>
              <Row className="mb-5">
                <Col md={9}>
                  <Form.Control
                    type="text"
                    placeholder="PXXXXXX"
                    defaultValue=""
                    style={{ textTransform: 'uppercase' }}
                    onChange={(e) => setUserId(e.target.value)}
                    onKeyPress={handleEnterKey(searchUser)}
                  />
                </Col>
                <Col md={3}>
                  <Button variant="primary light w-100" onClick={searchUser}>
                    ค้นหา
                  </Button>
                </Col>
              </Row>
            </Form>
          ) : (
            <h3 className="text-center">
              {user.firstName} {user.lastName}
            </h3>
          )}
          {user.name && (
            <Form>
              <div className="mb-4">
                <Form.Label className="ml-2">เลขที่ต้องการ</Form.Label>
                <Row>
                  <Col md={6}>
                    <Form.Control
                      ref={numberForSearchRef}
                      type="text"
                      placeholder="000000"
                      defaultValue={numberForSearchRef?.current?.value}
                      onChange={(e) => validNumberForSearch(e)}
                      onKeyDown={handleEnterKey(searchLotteries)}
                    />
                  </Col>
                  <Col md={3}>
                    <Form.Control as="select" defaultValue="seires" onChange={(e) => setType(e.target.value)}>
                      <option value="series">ชุด</option>
                      <option value="single">เดี่ยว</option>
                    </Form.Control>
                  </Col>
                  <Col md={3}>
                    <Button variant="primary light w-100" onClick={searchLotteries}>
                      ค้นหา
                    </Button>
                  </Col>
                </Row>
              </div>
            </Form>
          )}
          {displayLotteriesFromSearched()}
          {displayLotteriesInCart()}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger light" onClick={closeModal}>
            ยกเลิก
          </Button>
          {Object.keys(cart).length > 0 && (
            <div>
              {(cart.series.length > 0 || cart.single.length > 0) && (
                <Button variant="primary light" onClick={createOrder}>
                  สร้างออเดอร์
                </Button>
              )}
            </div>
          )}
        </Modal.Footer>
      </Modal>
    </Fragment>
  )
}

export default CreateOrderModal
